import { render } from "./AdminOrderList.vue?vue&type=template&id=530a38fa"
import script from "./AdminOrderList.vue?vue&type=script&lang=js"
export * from "./AdminOrderList.vue?vue&type=script&lang=js"
script.render = render

export default script